import { translate, useLocale } from "../../localization";
import React from "react";

const ElementCloneIndicator = ({ isClone }) => {
  useLocale();
  if (!isClone) return null;

  return (
    <span
      className="elementCloneIndicator"
      title={translate("This element shares model data with another element.")}
    >{translate("Clone")}</span>
  );
};

export default ElementCloneIndicator;
